import { PackageTemplate, Partner, DKK, Package } from "@raskrask-dk/raskrask-utils"


export class PackageBF extends PackageTemplate {
    chosenPartner?: Partner
    private constructor(bfsmPackage: PackageTemplate, partner?: Partner) {
        super(
            bfsmPackage.service,
            bfsmPackage.id,
            bfsmPackage.packageName,
            bfsmPackage.multiplier,
            bfsmPackage.discountPercentage
        )
        this.chosenPartner = partner
    }

    static fromPackageTemplate(
        bfsmPackage: PackageTemplate,
        partner?: Partner
    ): PackageBF {
        return new PackageBF(bfsmPackage, partner)
    }

    static fromBFSMPackages = (
        packages: PackageTemplate[],
        partner?: Partner
    ): PackageBF[] => {
        return packages.map((thisPackage) =>
            PackageBF.fromPackageTemplate(thisPackage, partner)
        )
    }

    static fromPackageTemplatessAndPartners = (
        packages: PackageTemplate[],
        partners: Partner[]
    ): PackageBF[] => {
        const result: PackageBF[] = []
        partners.forEach((partner) => {
            const partnerKlippekorts = PackageBF.fromBFSMPackages(
                packages,
                partner
            )
            result.push(...partnerKlippekorts)
        })
        return result
    }

    public get getSaveMinAndFromPrice(): { saveMin: DKK; priceFrom: DKK } {
        const partner =
            this.chosenPartner !== undefined
                ? this.chosenPartner
                : this.service.cheapestPartner
        return this.SaveMinAndFromPrice(partner)
    }

    private SaveMinAndFromPrice = (
        partner: Partner
    ): { saveMin: DKK; priceFrom: DKK } => {
        const partnerPackage = Package.fromPackageTemplate(this, partner)

        //const priceFrom = this.getPrice(partner);
        const priceFrom = partnerPackage.getPrice()
        //const saveMin = partner.getPrice(this.service) * this.multiplier - priceFrom
        const saveMin = partnerPackage.getDiscountAmount()

        return { saveMin, priceFrom }
    }

    public serviceDuration = (): string =>
        (this.service.duration.toMillis() / 60 / 1000).toString()

    get label(): string {
        return this.packageName
    }

    get serviceName(): string {
        return this.service.name
    }

    get serviceTypeID(): number {
        return this.service.id
    }
}
